import React from "react";
import DetailContainer from "./DetailContainer";
import Scroll from "react-scroll";

export const SCROLL_TO_DETAIL_CONTAINER = "scroll_to_detail_container";

class ScrollableDetailContainer extends React.Component {
  componentDidMount() {
    Scroll.scroller.scrollTo(SCROLL_TO_DETAIL_CONTAINER, {
      duration: 750,
      smooth: true
    });
  }

  render() {
    return (
      <div name={SCROLL_TO_DETAIL_CONTAINER}>
        <DetailContainer>{this.props.children}</DetailContainer>
      </div>
    );
  }
}

export default ScrollableDetailContainer;
